import { render, staticRenderFns } from "./taskLeftover.vue?vue&type=template&id=063c920c"
import script from "./taskLeftover.vue?vue&type=script&lang=js"
export * from "./taskLeftover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports